import { staticYearList } from '../model/StaticVariables';
import axios from 'axios';
import { useEffect, useState } from 'react';

const App404 = () => {
    const style = {
        width: '100%',
        height: '45vh'
    };
    useEffect(() => {
        document.querySelector('#foundURL').innerHTML = '    ';
        document.querySelector('#fourUrl').innerHTML = '    ';
        // checkPreparedCountyMaps();
        checkDataDownloads();
    }, []);

    return (
        <div>
            <textarea id="foundURL" style={style}></textarea>
            <textarea id="fourUrl" style={style}></textarea>
        </div>
    );
};
export default App404;

const preparedCountyMapUrl = (obj) => {
    const { yearName, stateName, countyName } = obj;
    const stateSlug = stateName.replace(/ /g, '');
    return `https://svi.cdc.gov/Documents/CountyMaps/2020/${stateName}/${stateSlug}${yearName}_${countyName}.pdf`;
};

const readStatesCountiesFromXML = (xml, editFn) => {
    const outputArr = [];
    const states = xml.data.getElementsByTagName('State');
    for (var st of states) {
        const stateName = st.getAttribute('name');
        const counties = st.getElementsByTagName('County');
        for (var cnt of counties) {
            const countyName = cnt.getAttribute('name') || cnt.innerHTML;
            var obj = editFn({ stateName, countyName });

            outputArr.push(obj);
        }
    }
    return outputArr;
};
const hasAllStrings = (searchStr, ...args) => {
    var outcome = true;
    for (var str of args) {
        if (searchStr.toLowerCase().indexOf(str.toLowerCase()) === -1) {
            outcome = false;
        }
    }
    return outcome;
};
const checkDataDownloads = async () => {
    const stateList = await axios.get(`https://svi.cdc.gov/xmldata/SVI_StatesForDownload.xml`, { responseType: 'document' }).then((res) => {
        const states = res.data.getElementsByTagName('State');
        const out = [];
        for (var st of states) {
            var stName = st.getAttribute('value');
            if (stName !== 'US' && stName !== 'NA') out.push(stName);
        }
        return out;
    });

    var urlList = [];
    // var base = `https://svi.cdc.gov/Documents/Data`;
    var base = `https://grasp_internal_test.cdc.gov/svi2021/Documents_Data`;

    const generateDataFilesListByType = (type = 'db', ext = 'zip', year = 2000) => {
        var urlArr = [];

        urlArr.push(`${base}/${year}/${type}/SVI_${year}_US.${ext}`);
        urlArr.push(`${base}/${year}/${type}/SVI_${year}_US_COUNTY.${ext}`);
        for (var st of stateList) {
            var slug = st.replace(/ /g, '');
            urlArr.push(`${base}/${year}/${type}/states/${slug}.${ext}`);
            urlArr.push(`${base}/${year}/${type}/states_counties/${slug}_county.${ext}`);
        }
        return urlArr;
    };

    for (var year of staticYearList) {
        var zips = generateDataFilesListByType('db', 'zip', year.label);
        var csvs = generateDataFilesListByType('csv', 'csv', year.label);
        urlList = urlList.concat(zips, csvs);
    }
    urlList = urlList.filter((url) => {
        if (hasAllStrings(url, '2000', 'COUNTY')) return false;
        if (hasAllStrings(url, '2000', 'STATES', 'zip')) return false;
        if (hasAllStrings(url, '2000', 'PuertoRico.csv')) return false;

        if (hasAllStrings(url, '2010', 'COUNTY', 'csv')) return false;
        if (hasAllStrings(url, '2010', 'PuertoRico')) return false;
        if (hasAllStrings(url, '2010', 'states_counties')) return false;
        // if(hasAllStrings(url,'2010','zip')) return false
        return url;
    });

    const urlListz = await batch404Lookup(urlList);
    // const found404String = urlListz.found404.join(`
    // `);
    // const clearedStr = urlListz.cleared.join(`
    // `)
    // console.log('===> found 404s');
    // console.log(found404String);
    // document.querySelector('#foundURL').innerHTML=clearedStr
    // document.querySelector('#fourUrl').innerHTML=found404String
};

const checkPreparedCountyMaps = async () => {
    var yearFiles = await loadYearData();
    var year_state_county_arr = [];
    for (var xml of yearFiles) {
        let yearName = xml.yearName;
        let state_county_arr = readStatesCountiesFromXML(xml, (obj) => {
            obj.yearName = yearName;
            return obj;
        });
        year_state_county_arr = year_state_county_arr.concat(state_county_arr);
    }

    const search404Arr = year_state_county_arr.slice(0, 100).map(preparedCountyMapUrl);
    const found404 = await batch404Lookup(search404Arr);

    const found404String = found404.join(`
`);
    console.log('===> found 404s');
    console.log(found404String);
};

const batch404Lookup = async (arr) => {
    const found404 = [];
    const cleared = [];
    await Promise.all(
        arr.map(async (url) => {
            await axios
                .head(url)
                .then((res) => {
                    cleared.push(url);
                    document.querySelector('#foundURL').append(
                        url +
                            `
    `
                    );
                })
                .catch((err) => {
                    found404.push(url);
                    document.querySelector('#fourUrl').append(
                        url +
                            `
                `
                    );
                });
        })
    );
    console.log('AFETR lookus');
    return { found404, cleared };
};

const loadYearData = async () => {
    var yearFiles = staticYearList.slice(0, 1);

    const promises = yearFiles.map(async (yearFile) => {
        let yearName = yearFile.label;
        return axios.get(`/data/list/${yearName}_counties.xml`, { responseType: 'document' }).then((res) => {
            const xml = res.data;
            return { yearName, data: xml };
        });
    });
    return Promise.all(promises);
};
